document.addEventListener('cart:change', function(event) {
  console.log('cart-update');
  setTimeout(() => {
    initCartRecommendationsSwiper();
  }, 200);

  function updateMultiTierCartProgress(updatedCartTotal = null) {
  const container = document.querySelector('.cart-progress-container');
  if (!container) return;

  const cartTotal = updatedCartTotal !== null ? parseFloat(updatedCartTotal) : parseFloat(container.dataset.cartTotal) || 0;
  const successMsg = container.dataset.successMsg;
  
  const templates = {
    nodeTier1: container.dataset.msgTemplate1,
    nodeTier2: container.dataset.msgTemplate2,
    nodeTier3: container.dataset.msgTemplate3
  };

  const fillTrack = document.getElementById('cartProgressFill');
  const messageEl = document.getElementById('cartProgressMessage');
  const nodes = Array.from(container.querySelectorAll('.cart-progress__node'));

  if (!nodes.length) return;

  const Tiers = nodes.map(node => ({
    element: node,
    id: node.id,
    target: parseFloat(node.dataset.target)
  })).sort((a, b) => a.target - b.target);

  const maxTarget = Tiers[Tiers.length - 1].target;

  Tiers.forEach(tier => {
    if (cartTotal >= tier.target) {
      tier.element.classList.add('achieved');
    } else {
      tier.element.classList.remove('achieved');
    }
  });

  const calculatedFillPercent = Math.min((cartTotal / maxTarget) * 100, 100);
  if (fillTrack) fillTrack.style.width = `${calculatedFillPercent}%`;

  let activeMsg = successMsg;
  let nextTier = Tiers.find(tier => cartTotal < tier.target);

  if (nextTier) {
    const remainingAmount = Math.floor(nextTier.target - cartTotal);
    // .toFixed(0) completely drops trailing decimal values
    const formattedAmount = `₹${remainingAmount.toFixed(0)}`;
    const templateString = templates[nextTier.id] || "";
    
    activeMsg = templateString.replace('||amount||', formattedAmount);
  }

  if (messageEl) messageEl.innerHTML = activeMsg;
}

window.updateMultiTierCartProgress = updateMultiTierCartProgress;
});